/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

